import { Flex, Heading, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { BseQuestionDto } from "../../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../../common/auth/useLoggedInWithOrgContextState";
import { displayDateWithTime } from "../../../../../common/formatting/displayDateWithTime";
import { displayWrappedWithEllipsis } from "../../../../../common/formatting/displayWrappedWithEllipsis";
import { QuestionStatusTag } from "../../../buyer/view-single/questions/QuestionStatusTag";
import { SupplierQuestionComments } from "../../../buyer/view-single/questions/SupplierQuestionComments";

interface Props {
  isOpen: boolean;
  close: () => void;
  canAddComments: boolean;
  question: BseQuestionDto;
  addComment: (values: { comment: string; createAnnouncementDraft: boolean }) => Promise<void>;
  addCommentDisabledReason: string | null;
}

export const QuestionModal = ({ isOpen, close, question, addComment, addCommentDisabledReason }: Props) => {
  const authState = useLoggedInWithOrgContextState();
  const askedByIsMe =
    question.askedByPerson.id === authState.me.id && question.askedByOrgName === authState.selectedOrg.name;
  const askedByLabel = askedByIsMe ? t("you") : `${question.askedByPerson.firstName}`;
  return (
    <Modal isOpen={isOpen} onClose={close} size="3xl">
      <ModalOverlay />
      <ModalContent height="80%" maxHeight="80%">
        <ModalCloseButton />
        <ModalBody height="full" p={5}>
          <Flex flexDirection="column" height="full">
            <Heading as="h2" size="md" py="2">
              {displayWrappedWithEllipsis(question.subject, 60)}
            </Heading>
            <Flex borderRadius="md" w="full">
              <Flex w="full" alignItems={"center"}>
                <Text pr="2" fontSize={"sm"}>
                  {t("Asked by")} <b>{askedByLabel}</b> {t("in")} <b>{question.askedByOrgName}</b> {t("to")}{" "}
                  <b>{question.askedToOrganization}</b>, {displayDateWithTime(question.askedAt)}
                </Text>
                <QuestionStatusTag status={question.status} size="sm" />
              </Flex>
            </Flex>
            <SupplierQuestionComments
              addCommentDisabledReason={addCommentDisabledReason}
              addComment={addComment}
              question={question}
              showCreateAnnouncementDraft={false}
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
